import React from 'react'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'

interface LoanRecordsOverviewProps {
  data: any
}

const totalInstitutionMap: Record<string, string> = {
  '0': '0',
  '1': '0-9',
  '2': '9-14',
  '3': '15+',
}

const settledInstitutionMap: Record<string, string> = {
  '0': '0',
  '1': '0-5',
  '2': '5-9',
  '3': '9-14',
  '4': '14-17',
  '5': '17+',
}

export default function LoanRecordsOverview({ data }: LoanRecordsOverviewProps) {
  const theme = useTheme()

  const totalInstitutions = totalInstitutionMap[data?.loan_info_xyp_cpl0001] ?? '—'
  const settledInstitutions = settledInstitutionMap[data?.loan_info_xyp_cpl0002] ?? '—'
  const hasOverdue = data?.loan_info_xyp_cpl0044 === '1'

  return (
    <div className="mt-2">
      <Stack gap="md">
        <div className="flex flex-col gap-2">
          <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
            贷款记录概览
          </Text>
          <Text size="xs" className="text-gray-500">
            汇总借贷机构、结清情况及逾期状态,供信用评估参考。
          </Text>
        </div>
        <div className="grid gap-3 md:grid-cols-3">
          <SummaryItem label="贷款总机构数" value={`${totalInstitutions} 家`} subtitle="所有借贷机构" />
          <SummaryItem label="已结清机构数" value={`${settledInstitutions} 家`} subtitle="已完成还款机构" />
          <SummaryItem label="是否存在逾期" value={hasOverdue ? '是' : '否'} subtitle="未结清逾期状态" />
        </div>
      </Stack>
    </div>
  )
}

interface SummaryItemProps {
  label: string
  value: string
  subtitle?: string
}

function SummaryItem({ label, value, subtitle }: SummaryItemProps) {
  const theme = useTheme()

  return (
    <div
      className="rounded-lg border px-4 py-3"
      style={{ borderColor: theme.surfaceBorderColor, backgroundColor: theme.surfaceColor }}
    >
      <Text size="xs" className="text-gray-500">
        {label}
      </Text>
      <Text size="sm" fw={600} style={{ marginTop: '6px', color: theme.primaryColor }}>
        {value}
      </Text>
      {subtitle && (
        <Text size="xs" className="text-gray-400" style={{ marginTop: '4px' }}>
          {subtitle}
        </Text>
      )}
    </div>
  )
}
